/* ARCA LUCIA – ATELIER FILTER LAYER 2026-10
   Farbkreise für filter.p.m.arca.farbe + Dropdown-Steuerung der Desktop-Filterleiste. */
(() => {
  const COLOR_PARAM = 'filter.p.m.arca.farbe';
  const BAR = '.facets-vertical #FacetsWrapperDesktop';
  const desktop = window.matchMedia('(min-width: 990px)');

  const COLORS = {
    schwarz: '#1a1a1a',
    weiss: '#ffffff',
    creme: '#f2ead9',
    ecru: '#efe6d2',
    beige: '#d8c6a8',
    nude: '#e3c3a8',
    camel: '#b98a5a',
    cognac: '#9a5b2e',
    braun: '#6e4b33',
    grau: '#9b9b9b',
    anthrazit: '#3f3f3f',
    rot: '#a8232d',
    bordeaux: '#5e1a26',
    weinrot: '#5e1a26',
    rosa: '#efb7c3',
    pink: '#e46aa0',
    koralle: '#ef7f6a',
    orange: '#e2783a',
    gelb: '#f0cb46',
    grun: '#3d6b47',
    oliv: '#6b6b3a',
    khaki: '#a39a6b',
    turkis: '#2aa3a3',
    petrol: '#1f5f6b',
    blau: '#2f5597',
    hellblau: '#9cc3e6',
    dunkelblau: '#1d2b4a',
    navy: '#1d2b4a',
    lila: '#7a5aa6',
    violett: '#7a5aa6',
    flieder: '#c4a9d8',
    gold: 'linear-gradient(135deg, #f7e7a1 0%, #c9a227 45%, #f2d777 70%, #a8841f 100%)',
    silber: 'linear-gradient(135deg, #f4f4f4 0%, #b9b9b9 45%, #e6e6e6 70%, #9a9a9a 100%)',
    bronze: 'linear-gradient(135deg, #e0a66b 0%, #9c6430 55%, #c98d52 100%)',
    kupfer: 'linear-gradient(135deg, #e6a27a 0%, #a8592f 60%, #d08458 100%)',
    multicolor: 'conic-gradient(#e2783a, #f0cb46, #3d6b47, #2f5597, #7a5aa6, #e46aa0, #e2783a)',
    mehrfarbig: 'conic-gradient(#e2783a, #f0cb46, #3d6b47, #2f5597, #7a5aa6, #e46aa0, #e2783a)',
    bunt: 'conic-gradient(#e2783a, #f0cb46, #3d6b47, #2f5597, #7a5aa6, #e46aa0, #e2783a)',
    transparent: 'repeating-conic-gradient(#e6e6e6 0% 25%, #ffffff 0% 50%) 50% / 8px 8px'
  };
  const LIGHT = ['weiss', 'creme', 'ecru', 'transparent', 'silber'];
  const KEYS = Object.keys(COLORS).sort((a, b) => b.length - a.length);

  const normalize = (value) =>
    String(value || '')
      .toLowerCase()
      .replace(/ß/g, 'ss')
      .normalize('NFD')
      .replace(/[̀-ͯ]/g, '')
      .trim();

  const lookup = (value) => {
    const key = normalize(value);
    if (COLORS[key]) return { key, color: COLORS[key] };
    const match = KEYS.find((k) => key.includes(k));
    return match ? { key: match, color: COLORS[match] } : null;
  };

  const swatchFor = (value) => {
    const parts = String(value || '').split(/\s*[\/&+,]\s*/).filter(Boolean);
    if (parts.length > 1) {
      const a = lookup(parts[0]);
      const b = lookup(parts[1]);
      if (a && b && !a.color.includes('gradient') && !b.color.includes('gradient')) {
        return { color: `linear-gradient(135deg, ${a.color} 50%, ${b.color} 50%)`, light: LIGHT.includes(a.key) || LIGHT.includes(b.key) };
      }
    }
    const hit = lookup(value);
    if (!hit) return { color: 'repeating-linear-gradient(135deg, #e7e2dc 0 4px, #d3ccc4 4px 8px)', light: true };
    return { color: hit.color, light: LIGHT.includes(hit.key) };
  };

  const decorateSwatches = () => {
    document.querySelectorAll(`input[name="${COLOR_PARAM}"]`).forEach((input) => {
      const label = input.closest('label');
      if (!label || label.querySelector('.arca-swatch')) return;
      const { color, light } = swatchFor(input.value);
      const swatch = document.createElement('span');
      swatch.className = 'arca-swatch' + (light ? ' arca-swatch--light' : '');
      swatch.setAttribute('aria-hidden', 'true');
      swatch.style.setProperty('--arca-swatch', color);
      input.insertAdjacentElement('afterend', swatch);
      label.classList.add('arca-color-label');
      input.closest('li')?.classList.add('arca-color-item');
    });

    // Farbliste im Mobile-Drawer vollständig zeigen
    document.querySelectorAll(`input[name="${COLOR_PARAM}"]`).forEach((input) => {
      const scope = input.closest('details');
      if (!scope) return;
      scope.querySelectorAll('.show-more-item.hidden').forEach((item) => {
        item.classList.remove('hidden');
        item.hidden = false;
      });
      const more = scope.querySelector('show-more-button');
      if (more) more.hidden = true;
    });
  };

  const tagFilters = () => {
    document.querySelectorAll('details.js-filter, details.mobile-facets__details').forEach((details) => {
      if (details.querySelector('input[name="filter.p.vendor"]')) details.classList.add('arca-filter--vendor');
      if (details.querySelector(`input[name="${COLOR_PARAM}"]`)) details.classList.add('arca-filter--color');
      if (details.querySelector('input[name^="filter.v.price"]')) details.classList.add('arca-filter--price');
    });
  };

  /* ---------- Dropdowns ---------- */
  let openKey = null;
  const keyOf = (details) => details.dataset.index || details.id || '';
  const barDetails = () => Array.from(document.querySelectorAll(`${BAR} > details.js-filter`));

  const setOpen = (details, open) => {
    details.classList.toggle('arca-open', open);
    details.querySelector(':scope > summary')?.setAttribute('aria-expanded', open ? 'true' : 'false');
  };

  const closeAll = () => barDetails().forEach((d) => setOpen(d, false));

  const syncBar = () => {
    if (!desktop.matches) return;
    barDetails().forEach((details) => {
      if (!details.open) details.open = true; // Inhalt bleibt im DOM, Sichtbarkeit steuert CSS
      setOpen(details, openKey !== null && keyOf(details) === openKey);
    });
  };

  document.addEventListener('click', (event) => {
    if (!desktop.matches) return;
    const summary = event.target.closest(`${BAR} > details.js-filter > summary`);
    if (summary) {
      event.preventDefault();
      const details = summary.parentElement;
      const willOpen = !details.classList.contains('arca-open');
      closeAll();
      details.open = true;
      setOpen(details, willOpen);
      openKey = willOpen ? keyOf(details) : null;
      return;
    }
    if (!event.target.closest(`${BAR} > details.js-filter`)) {
      closeAll();
      openKey = null;
    }
  });

  document.addEventListener('keyup', (event) => {
    if (event.key !== 'Escape' || !desktop.matches) return;
    const open = document.querySelector(`${BAR} > details.arca-open`);
    if (!open) return;
    closeAll();
    openKey = null;
    open.querySelector(':scope > summary')?.focus();
  });

  /* ---------- Lauf + Neuaufbau nach Filterwechsel ---------- */
  let queued = false;
  const run = () => {
    if (queued) return;
    queued = true;
    requestAnimationFrame(() => {
      queued = false;
      tagFilters();
      decorateSwatches();
      syncBar();
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run, { once: true });
  } else {
    run();
  }

  const target = document.querySelector('#MainContent') || document.body;
  new MutationObserver(run).observe(target, { childList: true, subtree: true });
  document.addEventListener('arca:facets-updated', run);
  document.addEventListener('shopify:section:load', run);
  desktop.addEventListener?.('change', () => {
    openKey = null;
    if (!desktop.matches) barDetails().forEach((d) => d.classList.remove('arca-open'));
    run();
  });
})();
